import { HTMLAttributes } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { MODULE_NAME } from 'modules/Lawsuits/strings'
import { Instruction, InstructionItem } from './LawsuitInstructionList.style'

interface LawsuitInstructionListProps
  extends Partial<HTMLAttributes<HTMLUListElement>> {}

const LawsuitInstructionList = (props: LawsuitInstructionListProps) => {
  const { t } = useTranslation(MODULE_NAME)
  return (
    <Instruction {...props}>
      {Array(4)
        .fill('')
        .map((_, idx) => (
          <InstructionItem key={`useful-info-item-${idx}`}>
            <Trans
              i18nKey={`usefulInfo.instruction.${idx + 1}`}
              components={{ bold: <b /> }}
              t={t}
            />
          </InstructionItem>
        ))}
    </Instruction>
  )
}

export default LawsuitInstructionList
